import React from 'react';
import RemoveProductModal from './RemoveProductModal';

export default React.memo(RemoveProductModal);
